import { createElement as rc, useMemo, useEffect } from 'react';
import _Range from '../_abstractComponent/Range';
import useDbView from '../../hooks/useDbView';
import { filters, metadata } from 'lib_ui-services';
import { hooks } from 'lib_ui-primitives';
const { filterHelpers } = filters;
const { usePersistentState } = hooks;

const rangeTypes = {
    DateTime: { filter: 'dateRange', childComponentType: 'DatePicker' },
    Number: { filter: 'numberRange', childComponentType: 'TextInput', childComponentProps: { type: 'number' } }
};

const _p = { useDbView };
export const _private = _p;
export default function Range(props) {
    const {
        hNode,
        hNode: { propertyName, namespace, relation, id, fromInputHNode, toInputHNode }
    } = props ?? { hNode: {} };

    if (fromInputHNode.hNodeType !== toInputHNode.hNodeType) {
        throw new Error('Ranges of two different types are not supported.');
    }

    const filterType = rangeTypes[fromInputHNode.hNodeType].filter;

    const defaultFilters = useMemo(() => {
        return {
            [filterType]: filters[filterType].getFilter(null, null, hNode.propertyPath, hNode.fromInputHNode.format),
            ...filterHelpers.getDefaultFilters(hNode)
        };
    }, [hNode, filterType]);
    const [fromValue, setFromValue] = usePersistentState(
        `from-${propertyName}-${id}`,
        defaultFilters[filterType].fromValue ?? ''
    );
    const [toValue, setToValue] = usePersistentState(
        `to-${propertyName}-${id}`,
        defaultFilters[filterType].toValue ?? ''
    );
    const propertyPath = metadata.getPathToProperty(hNode);

    const { viewCriteria } = _p.useDbView(namespace, relation, undefined, hNode);
    useEffect(() => {
        viewCriteria.applyFilters(
            {
                ...defaultFilters,
                [filterType]: filters[filterType].getFilter(fromValue, toValue, propertyPath, fromInputHNode.format)
            },
            id
        );
    }, [propertyPath, fromValue, toValue, defaultFilters, viewCriteria, fromInputHNode.format, filterType, id]);

    return rc(_Range, {
        ...props,
        fromValue,
        setFromValue,
        toValue,
        setToValue,
        rangeTypes
    });
}
